@if (HasCriteria) {
@for (criterion of aggregateCriterias; track trackByCriterion($index, criterion)) {
<div>
    <standard-task [aggregateCriteria]="criterion"></standard-task>
</div>
}
}

@if (!HasCriteria) {
@for (criterion of Aggregates; track trackByAggregate($index, criterion)) {
<div>
    <standard-task [aggregate]="criterion"></standard-task>
</div>
}
}

@if (showMore) {
<div fxLayout="column" fxLayoutAlign="center center">
    <forge-icon-button (click)="handleShowMore($event)" dense aria-label="Show more">
        <forge-tooltip>Show more</forge-tooltip>
        <forge-icon name="chevron_double_down"></forge-icon>
    </forge-icon-button>
    <forge-divider style="width: 100%;"></forge-divider>
</div>
}